import { seoSections } from '@/mocks/categories';

export default function WhyUseSection() {
  const { whyUse } = seoSections;

  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <p className="text-sm font-semibold text-accent-600 uppercase tracking-wider mb-3">Zalety</p>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900 mb-4">
            {whyUse.title}
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {whyUse.items.map((item, index) => (
            <div
              key={item.label}
              className="group p-6 bg-background-100 rounded-xl border border-background-200 hover:border-accent-200 transition-all duration-300"
              style={{ animation: `fadeInUp 0.5s ease-out ${index * 0.08}s both` }}
            >
              <div className="w-10 h-10 flex items-center justify-center bg-accent-100 rounded-lg mb-4 group-hover:bg-accent-200 transition-colors">
                <i className="ri-check-double-line text-lg text-accent-600"></i>
              </div>
              <h3 className="font-heading text-lg font-semibold text-foreground-900 mb-2">{item.label}</h3>
              <p className="text-sm text-foreground-500 leading-relaxed">{item.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}